import { DatePicker, Descriptions } from "antd";
import moment from "moment";
import QueryString from "qs";
import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import { IClass } from "../../../models/campusClasses.model";
import { ITimetable } from "../../../models/campusClasses3.model";

interface IProps {
  classData: IClass|undefined;
  timetables: ITimetable[]|undefined;
  timetableCode?: number|undefined;
  setTimetableCode?: (timetableCode: number|undefined) => void;
  noUseQuery?: boolean;
}

const DateTable: FC<IProps> = ({
  classData,
  timetables,
  timetableCode,
  setTimetableCode,
  noUseQuery,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  const [date, setDate] = useState('');

  useEffect(() => {
    if (query.date) {
      setDate(String(query.date));
    } else {
      const _timetableCode = sessionStorage.getItem('timetableCode');
      if (_timetableCode && setTimetableCode) {
        setTimetableCode(Number(_timetableCode));
      }
    }
  }, [location]);

  return (
    <div className='comm-table__area rowType'>
      <Descriptions
        bordered
        column={4}
        size="small"
        labelStyle={{ width: '12.5%' }}
        contentStyle={{ width: '12.5%' }}
      >
        <Descriptions.Item label={t('class.class.column52')}>
          {classData?.courseDetailName}
        </Descriptions.Item>
        <Descriptions.Item label={t('class.class.column53')}>
          {classData?.courseName}
        </Descriptions.Item>
        <Descriptions.Item label={t('class.class.column54')}>
          {classData?.courseSubName}
        </Descriptions.Item>
        <Descriptions.Item label={t('class.class.column81')}>
          <div className="date-picker__area">
            <DatePicker
              value={
                noUseQuery && timetableCode
                  ? moment(timetables?.find(item => Number(item.timetableCode) === timetableCode)?.srtDate)
                  : (date ? moment(date) : undefined)
              }
              onChange={e => {
                if (e) {
                  const timetable = timetables?.find(item => item.srtDate === moment(e).format('YYYYMMDD'));

                  if (noUseQuery && setTimetableCode) {
                    setTimetableCode(timetable?.timetableCode || undefined);
                  } else {
                    history.push(`/class?classCode=${query.classCode}&timetableCode=${timetable?.timetableCode}&date=${moment(e).format('YYYYMMDD')}`);    
                  }
                }
              }}
              disabledDate={current => {
                const timetable = timetables?.find(item => item.srtDate === moment(current).format('YYYYMMDD'));
                return timetable ? false : true;
              }}
            />
          </div>
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
}

export default DateTable;
